import * as bi from 'react-bootstrap-icons';
import { IClientCityBrief } from '@bustickus/models-client';
import { Flex, Modal, Scroll } from 'components';
import './style.scss';

interface IProps {
  cities: IClientCityBrief[];
  onSelect: (city: IClientCityBrief) => void;
  onClose: () => void;
}

function ModalSelectCity(props: IProps) {
  return (
    <Modal
      size={400}
      onClose={props.onClose}
      header='Выбор города'
    >
      <div className='cities-list-91jas'>
        <Scroll>
          <Flex
            direction='column'
            gap={10}
          >
            {props.cities.map((city) => (
              <CityButton
                key={city.id}
                city={city}
                onClick={() => props.onSelect(city)}
              />
            ))}
          </Flex>
        </Scroll>
      </div>
    </Modal>
  );
}

function CityButton(props: { city: IClientCityBrief; onClick: () => void }) {
  return (
    <Flex
      gap={10}
      onClick={props.onClick}
      className='city-btn-lK1j3'
    >
      <div className='city-btn-icon-aJ1a'>
        <bi.Buildings />
      </div>
      <Flex direction='column'>
        <div>{props.city.name}</div>
        <div className='city-btn-region-lAjda6'>
          {props.city.country?.name}, {props.city.region}
        </div>
      </Flex>
    </Flex>
  );
}

export default ModalSelectCity;
